import { Plus } from "lucide-react";
import { Button } from "./ui/button";

interface CreateGroupItemProps {
  onClick: () => void;
}

export function CreateGroupItem({ onClick }: CreateGroupItemProps) {
  return (
    <Button variant="outline" className="w-full justify-start text-left font-normal mb-2" onClick={onClick}>
      <Plus className="mr-2 h-4 w-4" />
      データ管理タグを作成
    </Button>
  );
}
